import './badge.scss';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { IconNames } from '@sola/schema/lib/icons/icon-names.js';
import { BadgeColors } from '@sola/schema/lib/schema.js';

import { cn } from '../../utils/helpers';

export interface BadgeProps {
  label: string;
  size?: 'sm' | 'md' | 'lg';
  color?: BadgeColors;
  iconBefore?: IconNames;
  allowWrap?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({
  label,
  size = 'md',
  color,
  iconBefore,
  allowWrap = false,
}) => {
  return (
    <span
      className={cn(
        `Badge Badge--${size} gap-snug-xl label-potent label-${size} flex items-center`,
        {
          [`Badge--${color}`]: !!color,
        },
      )}
      title={label}
    >
      {iconBefore && <ArkIcon iconName={iconBefore} />}
      <span
        className={cn('Badge__text', {
          'Badge__text--wrap': allowWrap,
        })}
      >
        {label}
      </span>
      {/* {labelValue} */}
    </span>
  );
};
